<template>
  <div class="row mb-2">
    <div class="col-12">
      <div class="card card-body">
        <h1 class="important-date-title">{{importantDate.event_name}}</h1>

        <h6 class="mt-2 text-muted important-date-header">{{importantDate.term_description}}</h6>

        <p v-html="importantDate.description"></p>

        <p class="text-muted text-uppercase">Sessions</p>

        <div v-for="session in importantDate.event_sessions"  :key="session.id" class="row mb-3">
          <div class="col-12 col-md-4">
            {{  formatDate(session.date) }}
          </div>
          <div class="col-12 col-md-4">
            {{  session.location }}
          </div>
          <div class="col-12 col-md-4 d-flex">
            <template v-if="session.sign_up_required">
              <a :href="session.sign_up_link" class="btn btn-sign-up-required">Sign Up</a>
            </template>
            <template v-else>
              <span class="btn-sign-up-not-required btn disabled" title="No sign up required">Sign Up Not Required</span>
            </template>
          </div>
          
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
import formatDateMixin from "../../mixins/formatDateMixin";

export default {
  name: 'ImportantDate',
  components: {},
  loading: false,
  props: {
    importantDate: Object
  },
  mixins: [formatDateMixin],
  created() {

  },
  mounted() {
    this.loading = true;
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {

  }
}
</script>
<style scoped>


</style>